export default __webpack_public_path__ + "assets/img/process_loader-4.be486c28.gif";